module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-additional-integrations@2x-71ff8362aa537fbbcd5264c34ed920d4.png";